import { useMemo } from "react"
import { Chip, ChipProps } from "@mui/material"

type NotificationCategoryChipProps = {
	category: string
}
export const NotificationCategoryChip = ({
	category
}: NotificationCategoryChipProps) => {
	const categoryChipProps = useMemo<ChipProps>(
		() => {
			if (category === "release") return { label: 'リリース', color: 'success' }
			if (category === "info") return { label: '情報', color: 'info' }
			if (category === "bug") return { label: 'BugFix', color: 'error' }
			return { label: '不明', color: 'default' }
		},
		[category]
	)
	return <Chip {...categoryChipProps} size="small"/>
}

